import React from 'react';
import { Route, Switch, Link } from 'react-router-dom';

import './Dashboard.scss';
import Footer from 'Dashboard/Footer';
import Sidebar from 'Dashboard/Sidebar';
import { MainMenu } from 'Dashboard/Config';

import AssetsPane from 'Dashboard/Panes/Assets';
import WelcomePane from 'Dashboard/Panes/Welcome';
import BlogEditorPane from 'Dashboard/Panes/BlogEditor';
import PageEditorPane from 'Dashboard/Panes/PageEditor';

import LoadingView from 'Core/Status/LoadingView';
import AppController from 'RLX/Controllers/AppController';

class Dashboard extends AppController {
  constructor (props) {
    super(props);
  }

  render () {
    const appData = this.state;
    const { initialStateLoaded, unsavedChanges } = appData.ui;
    const { location } = this.props;
    return !initialStateLoaded ? <LoadingView/> : (
      <div className="Dashboard">
        <Sidebar menus={MainMenu(appData)} location={location}>
          <Link to="/RLX/dash/">
            <img src="/assets/RLX-white.png" className="Logo" />
          </Link>
        </Sidebar>
        <main className="Dashboard-PaneContainer">
          <Switch>
            <Route exact path="/RLX/dash" component={WelcomePane} />
            <Route exact path="/RLX/login" component={WelcomePane} />

            <Route path="/RLX/dash/pages/:id" component={PageEditorPane} />
            <Route path="/RLX/dash/pages" component={PageEditorPane} />

            <Route path="/RLX/dash/blogs/:id" component={BlogEditorPane} />
            <Route path="/RLX/dash/blogs" component={BlogEditorPane} />

            <Route path="/RLX/dash/assets" component={AssetsPane} />
          </Switch>
          <Footer />
        </main>
      </div>
    )
  }
};

export default Dashboard;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Dashboard.jsx